/**
 * stringifyUrlSearch.js
 *
 * @Author: apple
 * @Date: 2017/10/19 15:54
 */

const stringifyUrlSearch = url => {
  const searchObj = {};
  const searchStr = (url || window.location.href).split('?')[1];
  searchStr
    && decodeURIComponent(searchStr)
      .split('&')
      .forEach(item => {
        const searchItem = item.match(/([^=]+)=([^]+)/);
        searchObj[searchItem[1]] = searchItem[2];
      });
  return searchObj;
};

export default stringifyUrlSearch;
